import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Grid,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from 'react-bootstrap'
import firebase from '../modules/Firebase'

class LoginForm extends Component {
  state = {
    formState: null,
    email: window.localStorage.getItem('emailForLogin') || '',
    firstRender: true,
    error: false,
  }

  isVerifyPhase = firebase.auth().isSignInWithEmailLink(window.location.href)

  sendLink = () => {
    const { email } = this.state
    const actionCodeSettings = {
      url: window.location.origin,
      handleCodeInApp: true,
    }

    firebase.auth()
      .sendSignInLinkToEmail(email, actionCodeSettings)
      .then(() => {
        window.localStorage.setItem('emailForLogin', email)
        this.setState({
          formState: 'success',
        })
      })
      .catch((error) => {
        this.setState({
          error: error.message,
          email: '',
        })
      })
  }

  login = () => {
    const { email } = this.state
    firebase.auth()
      .signInWithEmailLink(email, window.location.href)
      .then((result) => {
        window.localStorage.removeItem('emailForLogin')
      })
      .catch((error) => {
        this.setState({
          error: error.message,
          email: '',
        })
      }).finally(() => {
        this.props.history.replace({
          search: null,
        })
      })
  }

  handleEmailChange = (e) => {
    this.setState({
      email: e.target.value,
    })
  }
 
  handleOnSubmit = (e) => {
    e.preventDefault()
    const { email } = this.state
    if (email) {
      if (this.isVerifyPhase){
        this.login()
      } else {
        this.sendLink()
      }
    }
  }

  componentDidMount() {
    const { email, firstRender } = this.state;
    if (this.isVerifyPhase && email && firstRender) {
      this.login()
    } else {
      this.setState({
        firstRender: false,
      })
    }
  }

  render() {
    const { formState, email, firstRender, error } = this.state
    if (error) {
      return (
        <Grid>
          <Row className="show-grid">
            <Col md={12}>
              <h3>Something Went Wrong</h3>
            </Col>
          </Row>
          <Row className="show-grid">
            <Col md={12}>
              <p>{error}</p>
              <p>
                <Button bsStyle="primary" type="button" onClick={() => { window.location.reload() }}>Reload</Button>
              </p>
            </Col>
          </Row>
        </Grid>
      )
    }

    if (this.isVerifyPhase && email && firstRender) {
      return (
        <Grid>
          <Row className="show-grid">
            <Col md={12}>
              <h3>Logging in...</h3>
            </Col>
          </Row>
        </Grid>
      )
    }

    return (
      <Grid>
        <Row className="show-grid">
          <Col md={12}>
            <h3>{this.isVerifyPhase ? 'Verify Email' : 'Login'}</h3>
          </Col>
        </Row>
        <Row className="show-grid">
          <Col md={12}>
            <form onSubmit={this.handleOnSubmit}>
              <FormGroup validationState={formState}>
                <ControlLabel>{this.isVerifyPhase ? 'Verify' : 'Enter'} your email address</ControlLabel>
                <FormControl type="email" id="email" placeholder="e.g. user@stv.tv" value={email} onChange={this.handleEmailChange} />
                {formState === 'success' ? <p>Your login link has been emailed to {email}. Please check your email.</p> : null}
              </FormGroup>
              <Button bsStyle="primary" type="submit">Submit</Button>
            </form>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default withRouter(LoginForm)



// WEBPACK FOOTER //
// ./src/components/LoginForm.js